import React, { useEffect, useState } from 'react';
import { FooterBarItem } from '../cash-register/footer-bar/footer-bar-item';
import { AppStackScreenProps } from '../../routes';
import { useNavigation } from '@react-navigation/native';
import { useT } from '../../utils/helper';
import { useOrders } from '../../contexs/orders-context';

enum PulsatingState {
  Once,
  Continuous,
  None,
}

interface OnlineButtonProps {
  isOnline: boolean;
}

export const OnlineButton = (props: OnlineButtonProps) => {
  // General hooks
  const navigation =
    useNavigation<AppStackScreenProps<'StoreArea'>['navigation']>();
  const t = useT('cashRegister');
  // Custom hooks
  const { registerCallback } = useOrders();
  // States
  const [pulsatingState, setPulsatingState] = useState<PulsatingState>(
    PulsatingState.None,
  );

  // Effects
  // When there's new order, pulsate the online button to notify the cashier
  useEffect(() => {
    // Listener for new orders
    const unregisterCallback = registerCallback(
      'onlineButton',
      (newOrders, orders) => {
        const anyUnestimatedOrder = orders.find(order => !order.estimated_at);
        // If there are unestimated orders, pulsate continuously
        if (anyUnestimatedOrder || newOrders.length > 0) {
          setPulsatingState(PulsatingState.Continuous);
        } else {
          setPulsatingState(PulsatingState.None);
        }
      },
    );

    return () => {
      unregisterCallback();
    };
  }, []);

  // Handlers
  const handlePulsateComplete = () => {
    if (pulsatingState === PulsatingState.Once) {
      setPulsatingState(PulsatingState.None);
    }
  };

  return (
    <FooterBarItem
      key={'online'}
      pulsating={!props.isOnline && pulsatingState !== PulsatingState.None} // Don't pulsate when active
      active={props.isOnline}
      onPress={() => navigation.navigate('VendorDashboard')}
      onPulsateComplete={handlePulsateComplete}
      text={t('online')}
    />
  );
};
